import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import Signout from '../pages/Signout';
import { RecoveryCallbackRedirect } from './RecoveryCallbackRedirect';

/**
 * Minimal app shell during password recovery: only reset-password (and signout).
 * No nav, AI panel, or main layout chrome.
 */
export function RecoveryLockedApp() {
    return (
        <div className="fixed inset-0 z-[200] bg-background">
            <RecoveryCallbackRedirect />
            <Routes>
                <Route path="/" element={<Navigate to="/reset-password" replace />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/password-reset" element={<Navigate to="/reset-password" replace />} />
                <Route path="/signout" element={<Signout />} />
                <Route path="/login" element={<Navigate to="/reset-password" replace />} />
                <Route path="*" element={<Navigate to="/reset-password" replace />} />
            </Routes>
        </div>
    );
}
